// crudl.ts
var CRUDL = class {
  http;
  _path;
  _creator;
  constructor(http, path, creator) {
    this.http = http;
    this._path = path;
    this._creator = creator || ((data) => data);
  }
  async create(source, parameters) {
    const response = await this.http.post(this._path, source, { parameters });
    return this._creator(response.data);
  }
  async read(key, parameters) {
    const response = await this.http.get(`${this._path}/${key}`, {
      acceptStatuses: [404],
      parameters
    });
    if (response.status === 404) return void 0;
    return this._creator(response.data);
  }
  async update(key, patch, parameters) {
    const response = await this.http.patch(`${this._path}/${key}`, patch, { parameters });
    return this._creator(response.data);
  }
  async delete(key, parameters) {
    await this.http.delete(`${this._path}/${key}`, { parameters });
  }
  async list(parameters) {
    const response = await this.http.get(this._path, { parameters });
    if (!Array.isArray(response.data)) {
      this.http.fail(response.request, response, "Response is not an array");
    } else {
      return response.data.map((object) => this._creator(object));
    }
  }
};
export {
  CRUDL
};
//# sourceMappingURL=crudl.mjs.map
